import { render, staticRenderFns } from "./CommentsTimeline.vue?vue&type=template&id=229c0b08&scoped=true&"
import script from "./CommentsTimeline.vue?vue&type=script&lang=js&"
export * from "./CommentsTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c0b08",
  null
  
)

export default component.exports